import { UserStatusType, } from '@zurich/api/party';
export const partyPepStatusUtils = {
    isWarning(value) {
        return value?.toLowerCase() === 'ja';
    },
};
export const partySanctionStatusUtils = {
    isWarning(value) {
        return value?.toLowerCase() === 'ja';
    },
};
const userActiveToStatusTypeMapper = {
    true: UserStatusType.hasAccount,
    undefined: UserStatusType.noAccount,
    false: UserStatusType.pendingRegistration,
};
export const getPartyStatusByActiveState = (isActive) => userActiveToStatusTypeMapper[isActive?.toString() ?? 'undefined'];
